/**
 * Auction Hub Grid — Filter counts, image preloading, scroll restoration, page-view tracking
 * Extracted from auction-hub-grid.liquid
 *
 * Reads config from window.MHV_AUCTION_HUB_CONFIG (set by Liquid or localStorage fallback)
 */
(function() {
  'use strict';

  // ===== Filter Count Fetching =====

  function initFilters() {
    var config = window.MHV_AUCTION_HUB_CONFIG || {};
    var bidderNumber = config.bidderNumber || '';
    var consignorNumber = config.consignorNumber || '';
    var collectionHandle = config.collectionHandle || '';
    var filterContainer = document.getElementById('filterContainer');

    if (!bidderNumber || !filterContainer) return;

    // Set dynamic hrefs (may be empty from Liquid when not logged into Shopify)
    var bidsBtn = document.getElementById('showBidsBtn');
    var favsBtn = document.getElementById('showFavsBtn');
    var consignBtn = document.getElementById('showConsignmentsBtn');
    if (bidsBtn) bidsBtn.href = '/collections/' + collectionHandle + '/' + bidderNumber;
    if (favsBtn) favsBtn.href = '/collections/' + collectionHandle + '/' + bidderNumber + '-favs';
    if (consignBtn && consignorNumber) {
      consignBtn.href = '/collections/' + collectionHandle + '/' + consignorNumber + '-consignment';
    }

    // Set data-bidder-number on grid container (used by auction-hub-card-2.js for favorites)
    var productGrid = document.getElementById('ProductGridContainer');
    if (productGrid && !productGrid.getAttribute('data-bidder-number')) {
      productGrid.setAttribute('data-bidder-number', bidderNumber);
    }

    // Initialize count variables
    var bidCountValue = 0;
    var favCountValue = 0;
    var consignmentCountValue = 0;

    function updateFilterVisibility() {
      if (bidCountValue > 0 || favCountValue > 0 || consignmentCountValue > 0) {
        filterContainer.style.display = 'flex';
      } else {
        filterContainer.style.display = 'none';
      }
    }

    function updateFilterCount(filterType, elementId, filterClass, extraParams, attempt) {
      extraParams = extraParams || '';
      attempt = attempt || 1;
      var maxAttempts = 3;
      var url = MHV.SERVER_URL + '/filter-products?collection=' + collectionHandle + '&filter=' + filterType + '&bidder_number=' + bidderNumber + extraParams;

      mhvFetch(url)
        .then(function(response) {
          // Retry on 503 (DB temporarily unavailable) or 500
          if ((response.status === 503 || response.status === 500) && attempt < maxAttempts) {
            var delay = attempt * 2000; // 2s, 4s
            console.warn('Filter ' + filterType + ' got ' + response.status + ', retrying in ' + delay + 'ms (attempt ' + attempt + '/' + maxAttempts + ')');
            setTimeout(function() {
              updateFilterCount(filterType, elementId, filterClass, extraParams, attempt + 1);
            }, delay);
            return;
          }
          return response.json();
        })
        .then(function(data) {
          if (!data) return; // skipped due to retry
          var count = data.products_count || 0;
          var countElement = document.getElementById(elementId);
          if (countElement) {
            countElement.textContent = count;
          }

          if (filterType === 'bid') {
            bidCountValue = count;
          } else if (filterType === 'fav') {
            favCountValue = count;
          } else if (filterType === 'consignment') {
            consignmentCountValue = count;
          }

          var buttonContainer = document.querySelector('.' + filterClass);
          if (buttonContainer) {
            if (count > 0) {
              buttonContainer.style.display = 'block';
            } else {
              buttonContainer.style.display = 'none';
            }
          }

          updateFilterVisibility();
        })
        .catch(function(error) {
          console.error('Error fetching ' + filterType + ' filter count:', error);
          // Retry on network errors
          if (attempt < maxAttempts) {
            var delay = attempt * 2000;
            console.warn('Filter ' + filterType + ' network error, retrying in ' + delay + 'ms (attempt ' + attempt + '/' + maxAttempts + ')');
            setTimeout(function() {
              updateFilterCount(filterType, elementId, filterClass, extraParams, attempt + 1);
            }, delay);
          }
        });
    }

    updateFilterCount('bid', 'bidCount', 'bid-filter');
    updateFilterCount('fav', 'favCount', 'fav-filter');

    // Count + show one consignment filter per consignor this customer can access:
    // their own consignor_number plus any consignor where they are a linked contact.
    function countConsignmentFilter(num, countEl, containerEl, attempt) {
      attempt = attempt || 1;
      var url = MHV.SERVER_URL + '/filter-products?collection=' + collectionHandle + '&filter=consignment&bidder_number=' + bidderNumber + '&consignor_number=' + num;
      mhvFetch(url)
        .then(function(resp) {
          if ((resp.status === 503 || resp.status === 500) && attempt < 3) {
            setTimeout(function() { countConsignmentFilter(num, countEl, containerEl, attempt + 1); }, attempt * 2000);
            return null;
          }
          return resp.json();
        })
        .then(function(data) {
          if (!data) return;
          var count = data.products_count || 0;
          if (countEl) countEl.textContent = count;
          if (containerEl) containerEl.style.display = count > 0 ? 'block' : 'none';
          if (count > 0) { consignmentCountValue += count; filterContainer.style.display = 'flex'; }
        })
        .catch(function() { if (attempt < 3) setTimeout(function() { countConsignmentFilter(num, countEl, containerEl, attempt + 1); }, attempt * 2000); });
    }

    function setupConsignmentFilters() {
      mhvFetch(MHV.SERVER_URL + '/api/my-consignor-access')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var list = (data && data.consignors) || [];
          list.forEach(function(cn, idx) {
            var num = cn.consignorNumber;
            if (!num) return;
            if (cn.own && consignBtn) {
              // Reuse the static "Show My Consignments" button for the own consignor.
              consignBtn.href = '/collections/' + collectionHandle + '/' + num + '-consignment';
              countConsignmentFilter(num, document.getElementById('consignmentCount'), document.querySelector('.consignment-filter'));
            } else {
              // Build an extra filter button for a linked consignor (e.g. an estate),
              // labeled by its display title.
              var container = document.createElement('div');
              container.className = 'consignment-filter consignment-filter-linked';
              container.style.display = 'none';
              var countId = 'consignmentCountLinked-' + idx;
              var a = document.createElement('a');
              a.className = 'button';
              a.href = '/collections/' + collectionHandle + '/' + num + '-consignment';
              a.innerHTML = MHV.escapeHtml(cn.label || 'Consignments') + ' (<span id="' + countId + '">...</span>)';
              container.appendChild(a);
              filterContainer.appendChild(container);
              countConsignmentFilter(num, document.getElementById(countId), container);
            }
          });
        })
        .catch(function() {
          // Fallback: at least show the own consignor filter from injected config.
          if (consignorNumber && consignBtn) {
            countConsignmentFilter(consignorNumber, document.getElementById('consignmentCount'), document.querySelector('.consignment-filter'));
          }
        });
    }
    setupConsignmentFilters();
  }

  // ===== Page-View Tracking =====

  function sendPageView() {
    var config = window.MHV_AUCTION_HUB_CONFIG || {};
    if (!config.bidderNumber || !window.MHV_CUSTOMER_KEY) return;
    mhvFetch(MHV.SERVER_URL + '/api/page-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: 'auction-hub', collectionHandle: config.collectionHandle })
    }).catch(function() { /* silent */ });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // If profile is loading from localStorage (Facebook/email browser), wait for it
    var ready = window.MHV_CUSTOMER_KEY_READY || Promise.resolve();
    ready.then(function() {
      // Re-read config in case it was updated by the localStorage fallback
      var config = window.MHV_AUCTION_HUB_CONFIG || {};
      if (!config.bidderNumber && window.MHV_CUSTOMER_PROFILE) {
        config.customerEmail = window.MHV_CUSTOMER_PROFILE.email;
        config.bidderNumber = window.MHV_CUSTOMER_PROFILE.bidderNumber;
        config.consignorNumber = window.MHV_CUSTOMER_PROFILE.consignorNumber;
        window.MHV_AUCTION_HUB_CONFIG = config;
      }
      initFilters();
      sendPageView();
    });
  });

  // ===== Image Preloading & Scroll Restoration =====

  function preloadImage(img) {
    return new Promise(function(resolve) {
      img.loading = 'eager';
      img.removeAttribute('loading');

      if (img.srcset) {
        var srcsetUrls = img.srcset.split(',').map(function(src) { return src.trim().split(' ')[0]; });
        srcsetUrls.forEach(function(url) {
          var preloadLink = document.createElement('link');
          preloadLink.rel = 'preload';
          preloadLink.as = 'image';
          preloadLink.href = url;
          document.head.appendChild(preloadLink);
        });
      }

      if (img.complete) {
        resolve();
        return;
      }

      img.onload = resolve;
      img.onerror = resolve;
    });
  }

  function preloadProductImages(productElement) {
    if (!productElement) return Promise.resolve();

    var targetImages = productElement.querySelectorAll('img');
    var chain = Promise.resolve();
    targetImages.forEach(function(img) {
      chain = chain.then(function() { return preloadImage(img); });
    });

    return chain.then(function() {
      var prevProduct = productElement.previousElementSibling;
      var nextProduct = productElement.nextElementSibling;

      var neighborPromises = [];
      [prevProduct, nextProduct].forEach(function(neighbor) {
        if (neighbor) {
          var neighborImages = neighbor.querySelectorAll('img');
          neighborImages.forEach(function(img) {
            neighborPromises.push(preloadImage(img));
          });
        }
      });

      return Promise.all(neighborPromises);
    });
  }

  function scrollToLastViewedProduct() {
    var hash = window.location.hash;
    var productId = hash ? hash.substring(1) : sessionStorage.getItem('lastViewedProduct');
    var productGridEl = document.getElementById('product-grid');
    var sectionId = productGridEl ? productGridEl.dataset.id : null;

    if (productId && sectionId) {
      var cardLink = document.getElementById('CardLink-' + sectionId + '-' + productId);
      var productElement = (cardLink ? cardLink.closest('.card-wrapper') : null) ||
                           document.getElementById('CardWrapper-' + sectionId + '-' + productId);

      if (productElement) {
        var loadingOverlay = document.createElement('div');
        loadingOverlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.7);z-index:9999;display:flex;justify-content:center;align-items:center;transition:opacity 0.3s ease;';
        document.body.appendChild(loadingOverlay);

        var header = document.querySelector('header');
        var headerHeight = header ? header.offsetHeight : 0;
        var rect = productElement.getBoundingClientRect();
        var navEntries = performance.getEntriesByType('navigation');
        var isBackNavigation = navEntries.length > 0 && navEntries[0].type === 'back_forward';

        var initialScrollPosition;
        if (isBackNavigation) {
          initialScrollPosition = window.pageYOffset + rect.top - (window.innerHeight / 2) + (rect.height / 2) - headerHeight - (window.innerHeight * 0.5);
        } else {
          initialScrollPosition = window.pageYOffset + rect.top - headerHeight - (window.innerHeight * 0.5);
        }

        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = '-' + window.scrollY + 'px';

        window.scrollTo({ top: initialScrollPosition, behavior: 'auto' });

        preloadProductImages(productElement).then(function() {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.top = '';

          window.scrollTo({ top: initialScrollPosition, behavior: 'auto' });

          loadingOverlay.style.opacity = '0';
          setTimeout(function() { loadingOverlay.remove(); }, 300);
        });
      }

      if (!hash) {
        sessionStorage.removeItem('lastViewedProduct');
      }
    }
  }

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      scrollToLastViewedProduct();
    }
  });

  document.addEventListener('DOMContentLoaded', scrollToLastViewedProduct);
  window.addEventListener('hashchange', scrollToLastViewedProduct);

  window.addEventListener('beforeunload', function() {
    if (window.location.pathname.includes('/collections/auction-hub')) {
      sessionStorage.removeItem('lastViewedProduct');
    }
  });
})();
